import styled from 'styled-components';
import { Stack } from 'common/design-system/components-v2';

const TopDiv = styled(Stack)`
    flex-direction: column;
    width: 100%;
    height: 100%;
    gap: 16px;
`;

const PanelTopDiv = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
`;

const PanelTitleDiv = styled.div`
    display: flex;
    align-items: center;
    color: #354764;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
`;

export const ViewerStyled = {
    TopDiv,
    PanelTopDiv,
    PanelTitleDiv,
};
